import HttpClienteToken from '../../services/HttpClientToken';

import { UsuarioProps } from '../../interfaces/admin/UsuarioInterface';

export const Usuarios = () => {

    return new Promise<UsuarioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Usuario/', token)
            .then( ({ data } : { data :UsuarioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarUsuario = ( params:UsuarioProps ) => {

    return new Promise<UsuarioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Actualizar', params, token)
            .then( ({ data } : { data :UsuarioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idUsuario: 0,                 
                    nombre: '',
                    apellido1: '',
                    apellido2: '',
                    correoElectronico: '',
                    contrasena: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarUsuario = ( params:UsuarioProps ) => {

    return new Promise<UsuarioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Usuario/Agregar', params, token)
            .then( ({ data } : { data :UsuarioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idUsuario: 0,                 
                    nombre: '',
                    apellido1: '',
                    apellido2: '',
                    correoElectronico: '',
                    contrasena: '',
                    activo: false,        
                });
            });
        }

    });

}